import { render, staticRenderFns } from "./AggregateLearningLeaderboardUserProfileSheet.vue?vue&type=template&id=00a01e07&scoped=true"
import script from "./AggregateLearningLeaderboardUserProfileSheet.vue?vue&type=script&lang=js"
export * from "./AggregateLearningLeaderboardUserProfileSheet.vue?vue&type=script&lang=js"
import style0 from "./AggregateLearningLeaderboardUserProfileSheet.vue?vue&type=style&index=0&id=00a01e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a01e07",
  null
  
)

export default component.exports